import pure from "./higher-order/pure";
import React from "react";

export default pure(function TwitterFollowButton(props) {
  var { handle } = props;
  let twitterHref = "https://twitter.com/" + handle;
  return (
    <a className="twitter-follow-button" href={twitterHref}>
      Follow @
      {handle}
    </a>
  );
});

